import React, { useState, useEffect } from "react";
import "./App.css";

// Galeries par famille : titres = TITRES DES PHOTOS
const galerieFerronnerie = [
  {
    id: "f1",
    title: "Roses couleurs au choix",
    image: "/galerie1/Roses couleurs au choix.png",
    price: "75€",
    reserved: false,
    extraImages: [
      "/galerie1/Rose fuschia.jpg",
      "/galerie1/Rose jaune.jpeg",
      "/galerie1/Rose_rose_et_fuschia_chamaree.jpeg",
      "/galerie1/Rose_rouge_tige_en_metal_brut_vernie.jpeg",
      "/galerie1/Roses_en_metal_brut.png",
      "/galerie1/Roses_ metal_ brut_vernies.jpeg",
      "/galerie1/Roses rouge et jaune.jpeg",
      "/galerie1/Roses_rouges_avec_tiges_en_metal_brut.jpeg",
      "/galerie1/Rose orange et rouge chamarée.png",
      "/galerie1/Rose rose, fuschia et orange 2 chamarée.png",
      "/galerie1/Rose rose et fuschia chamarée.png",
      "/galerie1/Rose rose, fuschia et orange chamarée.png",
      "/galerie1/Rose orange et fuschia chamarée.png",
    ],
    description:
      "Roses en tôle d'acier découpées, soudées, formées et peintes à la main, couleurs personnalisables pour s’accorder à votre intérieur ou votre jardin. L'acier fait l'objet d'un brossage, d'un traitement avec un aprêt anti-corrosion, de 2 couches de peintures et 2 couches de vernis polyuréthane bi-compsant grand brillant résistant aux UV et aux intempéries. Elle est prête à piquer dans le sol avec une fourche anti-rotation en cas de vent et un trou d'évacuation de l'eau du coeur de la fleur dans l'axe de cette fourche.",
  },
  {
    id: "f2",
    title: "Coquelicot, Boutons d'Or, Marguerite... géants, Tulipe...",
    image: "/galerie1/Coquelicot_et_Boutons_d_Or_ geants.jpeg",
    price: "65€",
    reserved: false,
    enableFlowerType: true,
    enableSizeChoice: true,
    extraImages: [
      "/galerie1/Coquelicot_geant_35_40_cm.jpeg",
      "/galerie1/Bouton_d_or_geant.jpeg",
      "/galerie1/Marguerite_geante_2.jpeg",
      "/galerie1/Tulipe_taille_reelle.jpeg",
    ],
    description:
      "Coquelicots, Marguerites, Boutons d’or géants ou Tulipes, fleur et tiges en métal, tôle d'acier découpées, brossée, ébavurée, formées et peintes à la main, couleurs personnalisables pour s’accorder à votre intérieur ou votre jardin. L'acier fait l'objet d'un brossage, d'un aprêt anti-corrosion, de 2 couches de peinture et 2 couches de vernis polyuréthane bi-composant grand brillant résistant aux UV et aux intempéries. Pièces idéales pour massif ou grande jardinière. Les grandes tailles (35-40 cm) sont idéales pour décorer un massif ou une cabane de jardin située à plus de 30 m. Les tailles moyennes (25-30 cm) sont idéales pour décorer vos allées et coins de jardins de proximité.",
  },
  {
    id: "f3",
    title: "Coquelicot géant 35-40 cm",
    image: "/galerie1/Coquelicot_geant_35_40_cm.jpeg",
    price: "75€",
    reserved: false,
    extraImages: ["/galerie1/Coquelicot_geant_1.jpeg"],
    description:
      "Coquelicot géant de 35 à 40 cm, fleur rouge vif, avec son bouton sur tige séparée. Travail fin des pétales, cœur noir contrasté réalisé avec des pièces recyclées (un bruleur, un pommeau de douche supportant les étamines pour le coeur vert...). L'acier fait l'objet d'un brossage, ébavurage, d'un aprêt anti-corrosion, de 2 couches de peintures et 2 couches de vernis polyuréthane bi-compsant grand brillant résistant aux UV et aux intempéries.",
  },
  {
    id: "f4",
    title: "Roses en métal brut",
    image: "/galerie1/Roses_en_metal_brut.png",
    price: "75€",
    reserved: false,
    description:
      "Roses en métal brut, aspect industriel et poétique. L'acier fait l'objet d'un brossage suivi de 2 couches de vernis polyuréthane bi-compsant grand brillant anticorrosion et résistant aux UV et aux intempéries. Elle est prête à piquer dans le sol avec une fourche anti-rotation en cas de vent et un trou d'évacuation de l'eau du coeur de la fleur dans l'axe de cette fourche.",
  },
  {
    id: "f5",
    title: "Roses multicolore en tôle",
    image: "/galerie1/Roses_multicolore_en_tole.png",
    price: "75€",
    reserved: false,
    description:
      "Bouquet de roses multicolores en tôle, jeu de couleurs pastelles ou vives et chamarées. Un bouton de roses peut être rajouté sur demande (+ 10 €) pour préfigurer une relation naissante... L'acier fait l'objet d'un brossage, d'un aprêt anti-corrosion, de 2 couches de peintures et 2 couches de vernis polyuréthane bi-compsant grand brillant résistant aux UV et aux intempéries. Elles sont prêtes à piquer dans le sol avec une fourche anti-rotation en cas de vent et un trou d'évacuation de l'eau du coeur de la fleur dans l'axe de cette fourche.",
  },
  {
    id: "f6",
    title: "Tulipe couleur au choix",
    image: "/galerie1/Tulipe_taille_reelle.jpeg",
    price: "75€",
    reserved: false,
    description:
      "Tulipe couleur au choix. L'acier fait l'objet d'un brossage, ébavurage, d'un aprêt anti-corrosion, de 2 couches de peintures et 2 couches de vernis polyuréthane bi-compsant grand brillant résistant aux UV et aux intempéries. Pied anti rotation et trou d'évacuation de l'eau intégrés.",
  },
   {
    id: "f7",
    title: "Coquelicot géant taille medium 25-30 cm",
    image: "/galerie1/Coquelicot-3.png",
    price: "75€",
    reserved: true,
    enableFlowerType: true,
    enableSizeChoice: true,
    extraImages: [
      "/galerie1/Coquelicot-1.png",
      "/galerie1/Coquelicot-2.png",
      "/galerie1/Coquelicot-4.png",
    ],
    description:
      "Coquelicots et son bouton de 30-35 cm fleur et tiges en métal, tôle d'acier découpées, brossée, ébavurée, formées et peintes à la main.",
  },
];

const galerieArgentures = [
  {
    id: "a1",
    title: "Grive et ses paillettes orange sur son chêne",
    image: "/galerie2/Grive et ses paillettes orange sur son chêne.png",
    price: "120€",
    reserved: true,
    extraImages: [
      "/galerie2/Grive et ses paillettes orange sur son chêne_2.jpeg",
      "/galerie2/Grive et ses paillettes orange sur son chêne_3.jpeg",
      "/galerie2/Grive et ses paillettes orange sur son chêne_4.jpeg",
    ],
    description:
      "Grive penchée sur sa branche de chêne, en dix couverts d'argenterie, tête modelée en argent et laiton avec ses yeux rubis et son petit trésor de cristaux orange. Réservée.",
  },
  {
    id: "a2",
    title: "Grive contente de sa cerise",
    image: "/galerie2/Grive contente de sa cerise.jpeg",
    price: "120€",
    reserved: true,
    extraImages: [
      "/galerie2/Grive contente de sa cerise_2.jpeg",
      "/galerie2/Grive contente de sa cerise_3.jpeg",
      "/galerie2/Grive contente de sa cerise_4.jpeg",
    ],
    description:
      "Grive en 10 couverts argentés, tête brasée à l'argent et laiton regardant vers sa droite, yeux rubis en cristal Swarowski, posée avec sa cerise dans ses serres sur un silex de la clairière de Paucourt.",
  },
  {
    id: "a3",
    title: "Grive fière de sa tour de Bismuth",
    image: "/galerie2/Grive fière de sa tour de Bismuth.jpeg",
    price: "120€",
    reserved: true,
    extraImages: [
      "/galerie2/Grive et sa tour_2.jpeg",
      "/galerie2/Grive et sa tour_3.jpeg",
    ],
    description:
      "Grive en 10 couverts argentés, tête brasée à l'argent et laiton regardant en l'air de peur qu'on lui vole sa tour verte et dorée en cristal de bismuth, yeux oranges nids d'abeille en cristal Swarowski, posée sur son silex de 11 millions d'années de la clairière de Paucourt.",
  },
  {
    id: "a4",
    title: "Grive huppée avec ses cerises sur son fossile",
    image: "/galerie2/Grive huppée avec ses cerises sur son fossile.jpeg",
    price: "130€",
    reserved: false,
    extraImages: [
      "/galerie2/Grive huppée avec ses cerises sur son fossile_2.jpeg",
      "/galerie2/Grive huppée avec ses cerises sur son fossile_3.jpeg",
      "/galerie2/Grive huppée avec ses cerises sur son fossile_4.jpeg",
      "/galerie2/Grive huppée avec ses cerises sur son fossile_5.jpeg",
      "/galerie2/Grive huppée avec ses cerises sur son fossile.png",
    ],
    description:
      "Grive huppée (plume naturelle) en 10 couverts argentés, yeux émeraude en cristal Swarowski, posée avec ses cerises rouges sur un silex incrusté d'un coquillage fossile de plus de 11 millions d'années de la clairière de Paucourt. Ma première grive, sur une pierre magnifique !",
  },
  {
    id: "a5",
    title: "Les petits Martin-Pêcheurs et leurs trésors au choix",
    image: "/galerie2/Les petits Martin-Pêcheurs et leurs trésors au choix.png",
    price: "90€",
    reserved: false,
  },
  {
    id: "a6",
    title: "Pic-Pic vert sur son silex blanc",
    image: "/galerie2/Pic-Pic vert sur son silex blanc.jpeg",
    price: "90€",
    reserved: false,
    extraImages: ["/galerie2/Pic-Pic vert sur son silex blanc_2.jpeg"],
    description:
      "Martin-pêcheur stylisé en 5 couverts inox, vert moucheté de bleu à ventre orange et bec doré, yeux rubis en cristal Swarowski. Posé sur silex blanc de la clairière de Paucourt, il contemple avec contentement son joli galet veiné de rouge.",
  },
  {
    id: "a7",
    title: "Pic-Pic 1 et son cristal",
    image: "/galerie2/Pic-Pic 1 et son cristal.jpeg",
    price: "90€",
    reserved: false,
    extraImages: [
      "/galerie2/Pic-Pic 1 et son cristal_2.jpeg",
      "/galerie2/Pic-Pic 1 et son cristal_4.jpeg",
      "/galerie2/Pic-Pic 1 et son cristal_5.jpeg",
      "/galerie2/Pic-Pic 1 et son cristal_6.jpeg",
    ],
    description:
      "Martin-pêcheur stylisé en 5 couverts inox, couleurs doré et bruni irisées de bleu et bec doré, yeux émeraude vert clair en cristal Swarowski. Posé sur un silex de plus de 11 millions d'années de la clairière de Paucourt, il contemple avec contentement, les pieds dans l'eau, son petit trésor de cristaux orange.",
  },
  {
    id: "a8",
    title: "Pic-Pic bleu et son oeuf",
    image: "/galerie2/Pic-Pic bleu et son oeuf.png",
    price: "95€",
    reserved: true,
    extraImages: [
      "/galerie2/Pic-Pic bleu et son oeuf_2.jpeg",
      "/galerie2/Pic-Pic bleu et son oeuf_3.jpeg",
    ],
    description:
      "Martin-pêcheur stylisé en 5 couverts inox, bleu à ventre orange et bec doré, yeux saphir en cristal Swarowski. Posé sur un rare silex géode de la clairière de Paucourt, il couve avec amour cette géode qu'il prend pour son nid avec son galet blanc en forme d'oeuf.",
  },
  {
    id: "a9",
    title: "Pic-Pic bleu sur son silex rouge",
    image: "/galerie2/Pic-Pic bleu sur son silex rouge.jpeg",
    price: "90€",
    reserved: false,
    extraImages: ["/galerie2/Pic-Pic bleu sur son silex rouge_2.jpeg"],
    description:
      "Martin-pêcheur stylisé en 5 couverts inox, bec doré, yeux émeraude en cristal Swarowski. Posé sur silex rouge de la clairière de Paucourt, il contemple avec contentement son joli galet veiné multicolore.",
  },
  {
    id: "a10",
    title:
      "Piou-Piou au choix en suspension (décorations de sapins, couleur au choix)",
    image: "/galerie2/Pious-Pious en suspension (décorations de sapins).png",
    price: "28€",
    reserved: false,
    extraImages: [
      "/galerie2/Piou-Piou 1.png",
      "/galerie2/Piou-Piou 2.png",
      "/galerie2/Piou-Piou 3.png",
      "/galerie2/Piou-Piou 4.jpeg",
      "/galerie2/Piou-Piou 5.jpeg",
    ],
    description:
      "Piou-piou martin-pêcheur stylisé en 3 petites cuillères au choix inox ou couleur. Suspension pour mettre dans votre sapin ou faire un petit cadeau artisanal qui sera apprécié.",
  },
  {
    id: "a11",
    title: "Grive fière et sa grosse tour de Bismuth",
    image: "/galerie2/Grive et sa grosse tour de bismuth_6.jpeg",
    price: "120€",
    reserved: true,
    extraImages: [
      "/galerie2/Grive et sa grosse tour de bismuth_2.jpeg",
      "/galerie2/Grive et sa grosse tour de bismuth_3.jpeg",
      "/galerie2/Grive et sa grosse tour de bismuth_4.jpeg",
      "/galerie2/Grive et sa grosse tour de bismuth_5.jpeg",
      "/galerie2/Grive et sa grosse tour de bismuth_6.jpeg",
      "/galerie2/Grive et sa grosse tour de bismuth_7.jpeg",
    ],
    description:
      "Grive en 10 couverts argentés, tête brasée à l'argent et laiton regardant en l'air d'un air protecteur sa tour bleue et violette de Bismuth cristalisée, yeux orange nid d'abeille en cristal Swarowski, posée sur son silex blanc de 11 millions d'années de la clairière de Paucourt.",
  },
  {
    id: "a12",
    title:
      "Loriot d'or sur son silex rouge avec son trésor chatoyant noir",
    image:
      "/galerie2/Loriot d'or sur son silex rouge avec son trésor chatoyant noir.jpeg",
    price: "95€",
    reserved: true,
    extraImages: [
      "/galerie2/Loriot d'or sur son silex rouge avec son trésor chatoyant noir_2.jpeg",
      "/galerie2/Loriot d'or sur son silex rouge avec son trésor chatoyant noir_3.jpeg",
      "/galerie2/Loriot d'or sur son silex rouge avec son trésor chatoyant noir_4.jpeg",
      "/galerie2/Loriot d'or sur son silex rouge avec son trésor chatoyant noir_5.jpeg",
      "/galerie2/Loriot d'or sur son silex rouge avec son trésor chatoyant noir_6.jpeg",
      "/galerie2/Loriot d'or sur son silex rouge avec son trésor chatoyant noir_7.jpeg",
      "/galerie2/Loriot d'or sur son silex rouge avec son trésor chatoyant noir_8.jpeg",
    ],
    description:
      "Loriot d'or en 5 couverts inox, yeux vert clair Swarowski, sur son très beau silex rouge de la clairière de Paucourt. Il contemple avec fierté son trésor chatoyant noir.",
  },
  {
    id: "a13",
    title: "Pic-Pic bleu moucheté d'or en train de boire",
    image:
      "/galerie2/Pic-Pic bleu moucheté d'or en train de boire_4.jpeg",
    price: "90€",
    reserved: true,
    extraImages: [
      "/galerie2/Pic-Pic bleu moucheté d'or en train de boire_2.jpeg",
      "/galerie2/Pic-Pic bleu moucheté d'or en train de boire_3.jpeg",
      "/galerie2/Pic-Pic bleu moucheté d'or en train de boire.jpeg",
    ],
    description:
      "Pic-Pic bleu moucheté d'or en 5 couverts inox, yeux couleur citrine Swarowski, sur son silex blanc et orangé de la clairière de Paucourt. Il couve son galet rouge en se désaltérant dans une petite flaque d'eau.",
  },
  {
    id: "a14",
    title:
      "Pic-Pic bleu sur son bois pétrifié et son galet à vagues grises",
    image:
      "/galerie2/Pic-Pic bleu sur son bois pétrifié et son galet à vagues grises_5.jpeg",
    price: "95€",
    reserved: true,
    extraImages: [
      "/galerie2/Pic-Pic bleu sur son bois pétrifié et son galet à vagues grises_2.jpeg",
      "/galerie2/Pic-Pic bleu sur son bois pétrifié et son galet à vagues grises_3.jpeg",
      "/galerie2/Pic-Pic bleu sur son bois pétrifié et son galet à vagues grises_4.jpeg",
      "/galerie2/Pic-Pic bleu sur son bois pétrifié et son galet à vagues grises_6.jpeg",
    ],
    description:
      "Pic-Pic bleu sur son bois pétrifié, yeux vert clair Swarowski. Il contemple avec gourmandise son galet à vagues grises.",
  },
  {
    id: "a15",
    title: "Pic-Pic vert, ses fossiles et son papillon",
    image: "/galerie2/Pic-Pic vert, ses fossiles et son papillon_4.jpeg",
    price: "120€",
    reserved: false,
    extraImages: [
      "/galerie2/Pic-Pic vert, ses fossiles et son papillon_2.jpeg",
      "/galerie2/Pic-Pic vert, ses fossiles et son papillon_3.jpeg",
      "/galerie2/Pic-Pic vert, ses fossiles et son papillon_5.jpeg",
      "/galerie2/Pic-Pic vert, ses fossiles et son papillon_6.jpeg",
      "/galerie2/Pic-Pic vert, ses fossiles et son papillon_7.png",
    ],
    description:
      "Pic-Pic vert en 5 couverts inox, yeux vert clair Swarowski, sur une très jolie roche garnie de fossiles de coquillages. Un papillon bleu sculpté en laiton s'est également posé là pour contempler ces trésors de plus de 11 millions d'années.",
  },
  {
    id: "a16",
    title: "Pic-Pic vert et son fossile géant",
    image: "/galerie2/Pic-Pic vert et son fossile géant_2.jpeg",
    price: "120€",
    reserved: false,
    extraImages: [
      "/galerie2/Pic-Pic vert et son fossile géant_3.jpeg",
      "/galerie2/Pic-Pic vert et son fossile géant_4.jpeg",
      "/galerie2/Pic-Pic vert et son fossile géant_5.jpeg",
      "/galerie2/Pic-Pic vert et son fossile géant_6.jpeg",
    ],
    description:
      "Pic-Pic vert en 5 couverts inox, yeux rubis Swarowski, sur une très jolie roche formée dans sa pleine épaisseur autour d'un gros coquillage fossile de plus de 11 millions d'années.",
  },
  {
    id: "a17",
    title: "Pic-Pic vert sur sa boite en racine de tuya",
    image: "/galerie2/Pic-Pic vert sur sa boite en racine de tuya.png",
    price: "95€",
    reserved: true,
    extraImages: [
      "/galerie2/Pic-Pic vert sur sa boite en racine de tuya_2.png",
      "/galerie2/Pic-Pic vert su sa boite en racine de Tuya_3.png",
    ],
    description:
      "Pic-Pic vert en 5 couverts inox, yeux rubis Swarowski, sur sa très jolie boite en racine de tuya.",
  },
  {
    id: "a18",
    title: "Loriot et son bois fossilisé",
    image: "/galerie2/Loriot_1.jpeg",
    price: "90€",
    reserved: false,
    extraImages: [
      "/galerie2/Loriot_2.jpeg",
    ],
    description:
      "Loriot en 5 couverts inox, yeux rubis Swarowski, perché sur une tranche de bois petrifié.",
  },
  {
    id: "a19",
    title: "Martin-pêcheur au travail",
    image: "/galerie2/Pecheur_1.jpeg",
    price: "95€",
    reserved: false,
    extraImages: [
      "/galerie2/Pecheur_2.jpeg",
      "/galerie2/Pecheur_3.jpeg",
    ],
    description:
      "Martin-pêcheur au travail, réalisé en 5 couverts inox. Plumage bleu moucheté vert, poitrine orange, yeux saphir swarowski tenant un poisson dans son bec doré, gardien de son cristal de bismuth",
  },
  {
    id: "a20",
    title: "Martin Pécheur vert",
    image: "/galerie2/Pecheur vert_1.jpeg",
    price: "90€",
    reserved: false,
    extraImages: [
      "/galerie2/Pecheur vert_2.jpeg",
      "/galerie2/Pecheur vert_3.jpeg",
      "/galerie2/Pecheur vert_4.jpeg",
    ],
    description:
      "Martin-pêcheur vert en 5 couverts inox, yeux émeraude Swarowski, sur son silex avec sa petite mare orné d'un chrysoprase roulé signe du printemps.",
  },
  {
    id: "a21",
    title: "Martin pécheur sur son champigon et son escargot",
    image: "/galerie2/Champignon_5.jpeg",
    price: "130€",
    reserved: false,
    extraImages: [
      "/galerie2/Champignon_1.jpeg",
      "/galerie2/Champignon_2.jpeg",
      "/galerie2/Champignon_3.jpeg",
      "/galerie2/Champignon_4.jpeg",
      "/galerie2/Champignon_6.jpeg"
    ],
    description:
      "Martin-pêcheur vert en 5 couverts inox. Plumage vert, poitrine orange et yeux émeraude. Posé sur le garde-manger d'un petit escargot: un magnifique cépe d'été.",
  },  
  {
    id: "a22",
    title: "Piranga bourgogne perché sur son minerai rouge orangé",
    image: "/galerie2/Piranga bourgogne_1.jpeg",
    price: "130€",
    reserved: false,
    extraImages: [
      "/galerie2/Piranga bourgogne_2.jpeg",
      "/galerie2/Piranga bourgogne_3.jpeg",
      "/galerie2/Piranga bourgogne_4.jpeg",
      "/galerie2/Piranga bourgogne_5.jpeg",
      "/galerie2/Piranga bourgogne_6.jpeg",
    ],
    description:
      "Piranga bourgogne en 5 couverts inox, bec et queue dorés, yeux rubis Swarowski, monté sur un magnifiquminerai rouge orangé de 16 cm composé de vanadite et de pétales de barytine (Maroc).",
  },
];

const galerieCompositions = [
  {
    id: "c1",
    title: "Poisson sur son Corail",
    image: "/galerie3/Poisson sur son Corail.png",
    price: "180€",
    reserved: false,
    extraImages: [
      "/galerie3/Poisson recto.png",
      "/galerie3/Poisson verso.png",
      "/galerie3/Corail recto.png",
      "/galerie3/Corail verso.png",
      "/galerie3/Poisson dans son Corail.png",
    ],
    description:
      "Composition sous-marine. Poisson en bois d'olivier vernis serti de laiton sculpté et poli et ses nageoires en paille colorée du Vietnam, évoluant sur son corail pêché en Martinique et sa gorgone. Un tout petit poisson broute le corail gorgone. Alliance de corail, de minéral, de bois et de métal vous projetant dans les fonds marins pour décorer un salon ou une salle de bain.",
  },
  {
    id: "c2",
    title: "Le chêne, le roseau et les pêcheurss",
    image: "/galerie3/Le_Chene_le_Roseau_et_les_Pics_Pics_1.jpeg",
    price: "180€",
    reserved: false,
    extraImages: [
      "/galerie3/Le_Chene_le_Roseau_et_les_Pics_Pics_2.jpeg",
      "/galerie3/Le_Chene_le_Roseau_et_les_Pics_Pics_3.jpeg",
      "/galerie3/Le_Chene_le_Roseau_et_les_Pics_Pics_4.jpeg",
    ],
    description:
      "Composition : le chêne le roseau et les pêcheurs. Deux petits Martin-Pêcheurs en inox 5 couverts chacun, l'un bleu aux yeux jaunes, perché sur son roseau, l'autre sur son chêne, mordoré aux yeux Swarowski rubis, buvant avec insouciance dans une petite mare bleue.",
  },
  {
    id: "c3",
    title: "Loriot sur Ginkgo",
    image: "/galerie3/Le_Loriot_sur_son_Gingkgo_1.png",
    price: "180€",
    reserved: true,
    extraImages: [
      "/galerie3/Le_Loriot_sur_son_Gingkgo_2.png",
      "/galerie3/Le_Loriot_sur_son_Gingkgo_3.png",
    ],

    description:
      "Composition Ginko : Loriot posé sur un éventail de feuilles de ginkgo monté sur un magnifique silex rouge, pièce réservée.",
  },
  {
    id: "c4",
    title: "Rainette au pique-nique",
    image: "/galerie3/Rainette au pique-nique.jpeg",
    price: "220€",
    reserved: true,
    extraImages: [
      "/galerie3/Rainette 2.png",
      "/galerie3/Rainette 3.png",
      "/galerie3/Rainette en cours avant peinture.png",
    ],
    description:
      "Composition : la rainette au pique-ique. Sculpture très ouvragée en argent, inox et laiton magnifiquement colorée. La Rainette (verte avec son petit ventre rose !) est formée de 2 cuillères à soupe, 2 petites cuillères, deux écrous borgnes et des heures de brasure à l'argent. Couleurs pigmentées transparentes profondes et vivantes. À l'affut sur sa petite mare verte et bleue elle déguste son moustique attrapé au vol.",
  },
  {
    id: "c5",
    title: "Calliste à tête verte et son lombric",
    image: "/galerie3/Calliste à tête verte et son lombric.jpeg",
    price: "120€",
    reserved: false,
    extraImages: [
      "/galerie3/Calliste à tête verte et son lombric_2.jpeg",
      "/galerie3/Calliste à tête verte et son lombric_3.jpeg",
      "/galerie3/Calliste à tête verte et son lombric_4.jpeg",
      "/galerie3/Calliste à tête verte et son lombric_5.jpeg",
    ],
    description:
      "Composition sur un petit vide poche. Calliste vert et bleu à tête verte et bec doré, en 6 couverts inox, posé sur un vide poche ; il se délecte d'un lombric qu'il tire du fond d'une petite mare verte et bleue également.",
  },
 {
    id: "c6",
    title: "Lezard",
    image: "/galerie3/Lezard-10.jpeg",
    price: "280€",
    reserved: true,
    extraImages: [
      "/galerie3/Lezard-1.jpeg",
      "/galerie3/Lezard-3.jpeg",
      "/galerie3/Lezard-4.jpeg",
      "/galerie3/Lezard-5.jpeg",
      "/galerie3/Lezard-6.jpeg",
      "/galerie3/Lezard-7.jpeg",
      "/galerie3/Lezard-8.jpeg",
      "/galerie3/Lezard-9.jpeg", 
    ],
    description:
      "Composition. Le déjeuner du Lezard Vert. Lézard de 38 cm réalisé avec 10 cuillères inox, en train de déguster un frelon; avec son petit pion de repositionnement le rendant amovible de son rocher en silex.",
  },
  {
    id: "c7",
    title: "Colibri gourmand",
    image: "/galerie3/Colibri_0.jpeg",
    price: "220€",
    reserved: true,
    extraImages: [
      "/galerie3/Colibri_1.jpeg",
      "/galerie3/Colibri_2.jpeg",
      "/galerie3/Colibri_4.jpeg",
      "/galerie3/Colibri_5.jpeg",
      "/galerie3/Colibri_6.jpeg",
    ],
    description:
      "Composition. Le colibri gourmand: modellé avec 9 cuillères et couteaux en train de butiner une fleur en élévation au dessus d'une coupe (22 cm) en cerisier massif. Un croque-salade fait le tour de cette ravissante propriété et de son attirant lac intérieur bleu et vert.",
  },
]
// lien famille → galerie
const galerieParArtwork = {
  1: galerieFerronnerie,
  2: galerieArgentures,
  3: galerieCompositions,
};

// tous les items pour initialiser les réservations
const allItems = [
  ...galerieFerronnerie,
  ...galerieArgentures,
  ...galerieCompositions,
];

const initialReservedMap = allItems.reduce((acc, item) => {
  if (item.reserved) {
    acc[item.id] = true;
  }
  return acc;
}, {});

// === prix texte → nombre ===
const parsePrice = (price) => {
  if (typeof price === "number") return price;
  if (!price) return 0;
  const match = String(price).match(/[\d.,]+/);
  if (!match) return 0;
  const cleaned = match[0].replace(",", ".");
  const value = parseFloat(cleaned);
  return isNaN(value) ? 0 : value;
};

// === Composant Galerie (slider) ===
function Galerie({
  items,
  onAddToCart,
  enableColorChoice,
  setFullscreenImage,
  setFullscreenIndex,
  adminMode,
  reservedMap,
  onToggleReserve,
}) {
  const [index, setIndex] = useState(0);
  const [flowerColor, setFlowerColor] = useState("");
  const [stemColor, setStemColor] = useState("");
  const [flowerType, setFlowerType] = useState("");
  const [sizeChoice, setSizeChoice] = useState("");

  const [isMobile, setIsMobile] = useState(false);
  const [touchStartX, setTouchStartX] = useState(null);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window !== "undefined") {
        setIsMobile(window.innerWidth <= 768);
      }
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  if (!items || items.length === 0) {
    return <p style={{ fontSize: "0.8rem" }}>Aucune image dans cette galerie.</p>;
  }

  const current = items[index];
  const isReserved = reservedMap && reservedMap[current.id];

  const next = () => {
    setIndex((prev) => (prev + 1) % items.length);
  };

  const prev = () => {
    setIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  const handleAddToCart = () => {
    if (!onAddToCart) return;
    if (isReserved) {
      window.alert("Cette œuvre est réservée et ne peut plus être commandée.");
      return;
    }
    const itemToAdd = {
      ...current,
      ...(enableColorChoice && {
        flowerColor: flowerColor || undefined,
        stemColor: stemColor || undefined,
      }),
      ...(current.enableFlowerType && {
        flowerType: flowerType || undefined,
      }),
      ...(current.enableSizeChoice && {
        sizeChoice: sizeChoice || undefined,
      }),
    };
    onAddToCart(itemToAdd);
  };

  const handleFullscreen = () => {
    if (!setFullscreenImage) return;
    if (setFullscreenIndex) setFullscreenIndex(0);
    const allImages = [current.image, ...(current.extraImages || [])];
    setFullscreenImage({
      ...current,
      allImages,
    });
  };

  // Gestes tactiles (swipe)
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const endX = e.changedTouches[0].clientX;
    const diff = endX - touchStartX;
    const threshold = 50; // pixels

    if (diff > threshold) {
      // swipe droite → image précédente
      prev();
    } else if (diff < -threshold) {
      // swipe gauche → image suivante
      next();
    }
    setTouchStartX(null);
  };

  return (
    <div style={{ textAlign: "center", marginBottom: "0.8rem" }}>
      <div
        style={{
          border: "1px solid #8a6d3b",
          padding: "0.5rem",
          borderRadius: "10px",
          background:
            "radial-gradient(circle at top, #1a1307 0, #050404 50%, #000 100%)",
          boxShadow: "0 0 18px rgba(212,175,55,0.18)",
          position: "relative",
          overflow: "hidden",
          touchAction: "pan-y",
        }}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {isReserved && (
          <div
            style={{
              position: "absolute",
              top: 8,
              left: 8,
              backgroundColor: "rgba(123,27,27,0.95)",
              color: "#fff",
              padding: "0.2rem 0.6rem",
              borderRadius: "6px",
              fontSize: "0.75rem",
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              zIndex: 5,
            }}
          >
            RÉSERVÉ
          </div>
        )}

        <img
          src={current.image}
          alt={current.title}
          style={{
            width: "100%",
            maxHeight: "220px",
            objectFit: "contain",
            cursor: "pointer",
            transition: "opacity 0.3s ease",
          }}
          onClick={handleFullscreen}
        />

        {/* Flèches seulement sur DESKTOP */}
        {!isMobile && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "space-between",
              transform: "translateY(-50%)",
              padding: "0 0.3rem",
              pointerEvents: "none",
            }}
          >
            <button
              onClick={prev}
              style={{
                pointerEvents: "auto",
                background: "rgba(0,0,0,0.6)",
                border: "1px solid #d4af37",
                color: "#f9f3e5",
                borderRadius: "50%",
                width: "34px",
                height: "34px",
                cursor: "pointer",
                fontSize: "1.1rem",
              }}
            >
              ◀
            </button>
            <button
              onClick={next}
              style={{
                pointerEvents: "auto",
                background: "rgba(0,0,0,0.6)",
                border: "1px solid #d4af37",
                color: "#f9f3e5",
                borderRadius: "50%",
                width: "34px",
                height: "34px",
                cursor: "pointer",
                fontSize: "1.1rem",
              }}
            >
              ▶
            </button>
          </div>
        )}
      </div>

      {/* Indicateurs (petits points) sur mobile */}
      {isMobile && (
        <div
          style={{
            marginTop: "0.3rem",
            display: "flex",
            justifyContent: "center",
            gap: "6px",
          }}
        >
          {items.map((_, i) => (
            <span
              key={i}
              style={{
                width: i === index ? "9px" : "7px",
                height: i === index ? "9px" : "7px",
                borderRadius: "50%",
                backgroundColor: i === index ? "#d4af37" : "#555",
                transition: "all 0.2s ease",
              }}
            />
          ))}
        </div>
      )}

      {/* Titre précis de la photo */}
      <p
        style={{
          marginTop: "0.6rem",
          marginBottom: "0.1rem",
          color: "#f9f3e5",
          fontSize: "0.95rem",
          fontWeight: 500,
        }}
      >
        {current.title}
      </p>

      {/* Prix spécifique de cette photo */}
      <p
        style={{
          margin: 0,
          fontSize: "0.9rem",
          color: "#d4af37",
        }}
      >
        {current.price}
      </p>

      {/* Options couleurs (famille fleurs) */}
      {enableColorChoice && (
        <div
          style={{
            marginTop: "0.6rem",
            fontSize: "0.8rem",
            textAlign: "left",
            background: "rgba(10,10,10,0.8)",
            borderRadius: "8px",
            padding: "0.5rem",
            border: "1px solid #4a3a1f",
          }}
        >
          <label style={{ display: "block", marginBottom: "0.3rem" }}>
            Couleur(s) de la fleur :
            <input
              type="text"
              value={flowerColor}
              onChange={(e) => setFlowerColor(e.target.value)}
              placeholder="ex : rouge, jaune, rose, fuschia, blanc, rose chamarée fuschia, orange..."
              style={{
                width: "100%",
                marginTop: "0.2rem",
                padding: "0.3rem",
                borderRadius: "4px",
                border: "1px solid #8a6d3b",
                backgroundColor: "#050403",
                color: "#f9f3e5",
              }}
            />
          </label>
          <label style={{ display: "block", marginBottom: "0.3rem" }}>
            Couleur(s) de la tige / métal :
            <input
              type="text"
              value={stemColor}
              onChange={(e) => setStemColor(e.target.value)}
              placeholder="ex : vert, métal brut..."
              style={{
                width: "100%",
                marginTop: "0.2rem",
                padding: "0.3rem",
                borderRadius: "4px",
                border: "1px solid #8a6d3b",
                backgroundColor: "#050403",
                color: "#f9f3e5",
              }}
            />
          </label>
        </div>
      )}

      {/* Options spécifiques Coquelicot/Boutons d'Or géants */}
      {current.enableFlowerType && (
        <div
          style={{
            marginTop: "0.5rem",
            fontSize: "0.8rem",
            textAlign: "left",
            background: "rgba(10,10,10,0.8)",
            borderRadius: "8px",
            padding: "0.5rem",
            border: "1px solid #4a3a1f",
          }}
        >
          <label style={{ display: "block", marginBottom: "0.3rem" }}>
            Fleur :
            <select
              value={flowerType}
              onChange={(e) => setFlowerType(e.target.value)}
              style={{
                width: "100%",
                marginTop: "0.2rem",
                padding: "0.3rem",
                borderRadius: "4px",
                border: "1px solid #8a6d3b",
                backgroundColor: "#050403",
                color: "#f9f3e5",
              }}
            >
              <option value="">Choisir...</option>
              <option value="Coquelicot">Coquelicot</option>
              <option value="Bouton d'Or">Bouton d'Or</option>
            </select>
          </label>
        </div>
      )}

      {current.enableSizeChoice && (
        <div
          style={{
            marginTop: "0.5rem",
            fontSize: "0.8rem",
            textAlign: "left",
            background: "rgba(10,10,10,0.8)",
            borderRadius: "8px",
            padding: "0.5rem",
            border: "1px solid #4a3a1f",
          }}
        >
          <label style={{ display: "block", marginBottom: "0.3rem" }}>
            Taille :
            <select
              value={sizeChoice}
              onChange={(e) => setSizeChoice(e.target.value)}
              style={{
                width: "100%",
                marginTop: "0.2rem",
                padding: "0.3rem",
                borderRadius: "4px",
                border: "1px solid #8a6d3b",
                backgroundColor: "#050403",
                color: "#f9f3e5",
              }}
            >
              <option value="">Choisir...</option>
              <option value="25-30 cm">25-30 cm</option>
              <option value="35-40 cm">35-40 cm</option>
            </select>
          </label>
        </div>
      )}

      <p
        style={{
          marginTop: "0.2rem",
          fontSize: "0.75rem",
          color: "#c9b58a",
        }}
      >
        Image {index + 1} / {items.length}
      </p>

      {/* Bouton admin : réserver / annuler */}
      {adminMode && (
        <button
          onClick={() => onToggleReserve && onToggleReserve(current.id)}
          style={{
            marginTop: "0.3rem",
            background: "none",
            border: "1px dashed #d4af37",
            color: "#d4af37",
            padding: "0.3rem 0.7rem",
            cursor: "pointer",
            borderRadius: "999px",
            fontSize: "0.75rem",
          }}
        >
          {isReserved ? "Annuler la réservation" : "Marquer comme réservé"}
        </button>
      )}

      {/* Bouton pour ajouter CETTE photo au panier */}
      {onAddToCart && (
        <button
          onClick={handleAddToCart}
          disabled={isReserved}
          style={{
            marginTop: "0.4rem",
            background: isReserved
              ? "rgba(120,120,120,0.5)"
              : "linear-gradient(135deg, #f8e7b5 0%, #d4af37 45%, #b68a2b 100%)",
            color: isReserved ? "#ccc" : "#1a1307",
            border: "none",
            padding: "0.45rem 0.9rem",
            cursor: isReserved ? "not-allowed" : "pointer",
            borderRadius: "999px",
            fontWeight: "600",
            boxShadow: isReserved ? "none" : "0 0 10px rgba(212,175,55,0.4)",
          }}
        >
          {isReserved ? "Œuvre réservée" : "Ajouter cette œuvre au panier"}
        </button>
      )}
    </div>
  );
}

function App() {
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [fullscreenIndex, setFullscreenIndex] = useState(0);
  const [adminMode, setAdminMode] = useState(false);
  const [fsTouchStartX, setFsTouchStartX] = useState(null);

  // Réservations persistées dans localStorage
  const [reservedMap, setReservedMap] = useState(() => {
    if (typeof window === "undefined") return initialReservedMap;
    try {
      const stored = window.localStorage.getItem("reservedMap");
      if (stored) {
        const parsed = JSON.parse(stored);
        return { ...initialReservedMap, ...parsed };
      }
    } catch (e) {
      // ignore
    }
    return initialReservedMap;
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("reservedMap", JSON.stringify(reservedMap));
    } catch (e) {
      // ignore
    }
  }, [reservedMap]);

  const artworks = [
    {
      id: 1,
      familyName: "Ferronerie d'art déco de jardins",
      familyImage: "/galerie1/Roses couleurs au choix.png",
      familyPrice: "75€",
    },
    {
      id: 2,
      familyName: "L'Atelier des becs dorés et argentures vivantes",
      familyImage: "/galerie2/Becs dorés et Argentures vivantes.jpeg",
      familyPrice: "28 à 250€",
    },
    {
      id: 3,
      familyName: "Compositions vivantes",
      familyImage: "/galerie3/Poisson sur son Corail.png",
      familyPrice: "180 à 450€",
    },
  ];

  const addToCart = (item) => {
    if (!item) return;
    if (reservedMap[item.id]) {
      window.alert("Cette œuvre est réservée et ne peut plus être commandée.");
      return;
    }
    setCart((prev) => [...prev, item]);
  };

  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((i) => i.id !== id));
  };

  const cartTotal = cart.reduce(
    (sum, item) => sum + parsePrice(item.price),
    0
  );

  const handleMail = () => {
    const total = cart.reduce(
      (sum, item) => sum + parsePrice(item.price),
      0
    );

    const subject = encodeURIComponent(
      "Commande – Atelier Bertrand FLORENTZ"
    );

    const body = encodeURIComponent(
      `Bonjour,\n\n` +
        `Je souhaite passer commande pour les œuvres suivantes :\n\n` +
        cart
          .map((item, index) => {
            const base = `${index + 1}. ${item.title}${
              item.price ? ` (${item.price})` : ""
            }`;
            const optionsList = [];

            if (item.flowerColor) {
              optionsList.push(`fleur (couleur) : ${item.flowerColor}`);
            }
            if (item.stemColor) {
              optionsList.push(`tige/métal : ${item.stemColor}`);
            }
            if (item.flowerType) {
              optionsList.push(`type de fleur : ${item.flowerType}`);
            }
            if (item.sizeChoice) {
              optionsList.push(`taille : ${item.sizeChoice}`);
            }

            const options =
              optionsList.length > 0
                ? ` – Options : ${optionsList.join(", ")}`
                : "";

            return base + options;
          })
          .join("\n") +
        `\n\nMontant du panier : ${total.toFixed(2)} €\n\n` +
        `Mes coordonnées :\n` +
        `Nom : \nPrénom : \nAdresse postale complète : \n\n` +
        `Le règlement sera effectué par chèque.\n` +
        `Le chèque sera établi à l'ordre de : Bertrand FLORENTZ\n` +
        `Adresse pour l'envoi du chèque :\n` +
        `Bertrand FLORENTZ\n` +
        `560 rue de Cepoy\n` +
        `45200 Paucourt\n\n` +
        `Le colis pourra être expédié à réception de mon chèque.\n\n` +
        `Cordialement,\n` +
        `[Votre nom]`
    );

    window.location.href = `mailto:florentzb@wanadoo.fr?subject=${subject}&body=${body}`;
  };

  // Bouton admin avec mot de passe "Bertrand"
  const handleToggleAdmin = () => {
    if (!adminMode) {
      const pwd = window.prompt("Mot de passe administrateur :");
      if (pwd === "Bertrand") {
        setAdminMode(true);
      } else if (pwd !== null) {
        window.alert("Mot de passe incorrect.");
      }
    } else {
      setAdminMode(false);
    }
  };

  // Images plein écran
  const closeFullscreen = () => {
    setFullscreenImage(null);
    setFullscreenIndex(0);
  };

  const goPrevFullscreen = () => {
    if (!fullscreenImage || !fullscreenImage.allImages) return;
    setFullscreenIndex((prev) => {
      const max = fullscreenImage.allImages.length;
      return (prev - 1 + max) % max;
    });
  };

  const goNextFullscreen = () => {
    if (!fullscreenImage || !fullscreenImage.allImages) return;
    setFullscreenIndex((prev) => {
      const max = fullscreenImage.allImages.length;
      return (prev + 1) % max;
    });
  };

  const handleFsTouchStart = (e) => {
    setFsTouchStartX(e.touches[0].clientX);
  };

  const handleFsTouchEnd = (e) => {
    if (fsTouchStartX === null) return;
    const endX = e.changedTouches[0].clientX;
    const diff = endX - fsTouchStartX;
    const threshold = 50; // pixels pour le swipe

    if (diff > threshold) {
      // swipe droite → image précédente
      goPrevFullscreen();
    } else if (diff < -threshold) {
      // swipe gauche → image suivante
      goNextFullscreen();
    }
    setFsTouchStartX(null);
  };

  let fullscreenSrc = null;
  let fullscreenImages = [];
  if (fullscreenImage) {
    fullscreenImages =
      fullscreenImage.allImages && fullscreenImage.allImages.length > 0
        ? fullscreenImage.allImages
        : [fullscreenImage.image];
    fullscreenSrc =
      fullscreenImages[fullscreenIndex] || fullscreenImages[0];
  }

  return (
    <div
      style={{
        background:
          "radial-gradient(circle at top, #3b2a13 0, #050404 45%, #000 100%)",
        color: "#f8f3e8",
        minHeight: "100vh",
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >
      {/* HEADER */}
 <header
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.3rem 0.8rem", // 🔥 plus fin
    borderBottom: "1px solid #8a6d3b",
    background: "rgba(5,4,3,0.85)",
    backdropFilter: "blur(4px)",
    position: "sticky",
    top: 0,
    zIndex: 50,
    height: "48px", // 🔥 force une hauteur réduite
  }}
>
  <img
    src="/logo.png"
    alt="Atelier Bertrand FLORENTZ"
    style={{
      height: "32px", // 🔥 réduit le logo
      marginRight: "0.5rem",
    }}
  />

  <h1
    style={{
      flexGrow: 1,
      fontSize: "1rem", // 🔥 plus petit sur mobile
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      color: "#d4af37",
      margin: 0,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }}
  >
    Atelier Bertrand FLORENTZ
  </h1>

  <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
    <button
      onClick={() => setCartOpen(!cartOpen)}
      style={{
        background:
          "linear-gradient(135deg, #f8e7b5 0%, #d4af37 45%, #b68a2b 100%)",
        border: "none",
        color: "#1a1307",
        padding: "0.3rem 0.6rem",
        cursor: "pointer",
        borderRadius: "999px",
        fontSize: "0.75rem",
        fontWeight: "600",
      }}
    >
      Panier ({cart.length})
    </button>

    <button
      onClick={handleToggleAdmin}
      style={{
        background: "none",
        border: "1px solid #d4af37",
        color: adminMode ? "#d4af37" : "#f8f3e8",
        padding: "0.25rem 0.5rem",
        cursor: "pointer",
        borderRadius: "999px",
        fontSize: "0.7rem",
      }}
    >
            Admin
    </button>
  </div>
</header>

      <main>
        {/* GALERIE / ŒUVRES */}
        <section id="galerie" style={{ padding: "2.5rem 2rem 2rem" }}>
          <h2
            style={{
              textAlign: "center",
              marginBottom: "1.8rem",
              fontSize: "1.8rem",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "#f9f3e5",
            }}
          >
            Galerie / Œuvres
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "1.8rem",
            }}
          >
            {artworks.map((art) => (
              <div
                key={art.id}
                style={{
                  textAlign: "center",
                  border: "1px solid #8a6d3b",
                  padding: "1.2rem",
                  background:
                    "radial-gradient(circle at top, #1a1307 0, #050404 55%, #000 100%)",
                  boxShadow: "0 0 22px rgba(0,0,0,0.8)",
                  borderRadius: "14px",
                }}
              >
                {/* Image "type" de la famille – PLUS PETITE ET AU-DESSUS */}
                <img
                  src={art.familyImage}
                  alt={art.familyName}
                  style={{
                    width: "70%",
                    height: "auto",
                    objectFit: "contain",
                    marginBottom: "0.8rem",
                    borderRadius: "10px",
                    border: "1px solid #4a3a1f",
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                />

                {/* NOM DE LA FAMILLE */}
                <h3
                  style={{
                    marginTop: "0.1rem",
                    marginBottom: "0.2rem",
                    color: "#d4af37",
                    fontSize: "1.05rem",
                    letterSpacing: "0.16em",
                    textTransform: "uppercase",
                    fontWeight: 600,
                  }}
                >
                  {art.familyName}
                </h3>

                {/* Fourchette de prix de la famille */}
                <p
                  style={{
                    margin: 0,
                    marginBottom: "0.8rem",
                    color: "#d4af37",
                    fontWeight: 500,
                    fontSize: "0.9rem",
                    letterSpacing: "0.06em",
                  }}
                >
                  {art.familyPrice}
                </p>

                {/* Galerie : titres/prix des PHOTOS seulement */}
                <Galerie
                  items={galerieParArtwork[art.id]}
                  onAddToCart={addToCart}
                  enableColorChoice={art.id === 1}
                  setFullscreenImage={setFullscreenImage}
                  setFullscreenIndex={setFullscreenIndex}
                  adminMode={adminMode}
                  reservedMap={reservedMap}
                  onToggleReserve={(itemId) =>
                    setReservedMap((prev) => {
                      const updated = {
                        ...prev,
                        [itemId]: !prev[itemId],
                      };
                      try {
                        window.localStorage.setItem(
                          "reservedMap",
                          JSON.stringify(updated)
                        );
                      } catch (e) {
                        // ignore
                      }
                      return updated;
                    })
                  }
                />
              </div>
            ))}
          </div>
        </section>

        {/* DÉMARCHE ARTISTIQUE */}
        <section
          id="demarche"
          style={{
            padding: "2.5rem 2rem",
            borderTop: "1px solid #3b2a13",
            background: "rgba(5,4,3,0.85)",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              textTransform: "uppercase",
              letterSpacing: "0.14em",
              marginBottom: "1.2rem",
              color: "#d4af37",
            }}
          >
            Démarche artistique
          </h2>
          <p
            style={{
              maxWidth: "800px",
              margin: "1rem auto",
              textAlign: "justify",
              lineHeight: 1.7,
              color: "#d4af37",
            }}
          >
            Mes oeuvres vous emmènent dans un monde animalier poétique mariant le
            métal, le minéral et le bois pour donner vie à une pièce unique et
            émerveillante qui raconte une histoire entre un animal et son petit
            trésor. J’accorde une attention particulière à l'utilisation de
            matières naturelles et au recyclage, tels que des couverts
            en argenterie ou en inox enrichis de laiton, de pierres
            semi-précieuses et cristaux de Swarowski se mêlant aux formes et
            couleurs de pierres naturelles et bois ceuillies dans ma clairière.
            Chaque création est unique, façonnée, peinte et vernis avec soin et
            signée de sa plaquette dorée de mon Atelier situé au coeur de la
            forêt de Paucourt.
          </p>
        </section>

        {/* CONTACT */}
        <section
          id="contact"
          style={{
            padding: "2rem",
            borderTop: "1px solid #3b2a13",
            textAlign: "center",
            background: "rgba(0,0,0,0.9)",
          }}
        >
          <h2
            style={{
              textTransform: "uppercase",
              letterSpacing: "0.14em",
              marginBottom: "0.8rem",
              color: "#f8f3e8",
            }}
          >
            À propos / Contact
          </h2>
          <p>Atelier Bertrand FLORENTZ</p>
          <p>
            <a
              href="mailto:florentzb@wanadoo.fr"
              style={{
                color: "#f8f3e8",
                textDecoration: "none",
                borderBottom: "1px solid #d4af37",
                paddingBottom: "0.1rem",
              }}
            >
              florentzb@wanadoo.fr
            </a>
          </p>
        </section>
      </main>

      {/* PANIER POPUP */}
      {cartOpen && (
        <div
          style={{
            position: "fixed",
            top: "20%",
            right: "20px",
            background: "rgba(5,4,3,0.98)",
            padding: "1rem",
            border: "1px solid #8a6d3b",
            width: "280px",
            zIndex: 999,
            borderRadius: "12px",
            boxShadow: "0 0 18px rgba(0,0,0,0.9)",
          }}
        >
          <h3
            style={{
              marginTop: 0,
              marginBottom: "0.8rem",
              textTransform: "uppercase",
              letterSpacing: "0.12em",
              fontSize: "0.9rem",
              color: "#d4af37",
            }}
          >
            Panier
          </h3>
          {cart.length === 0 ? (
            <p>Aucun article</p>
          ) : (
            <>
              {cart.map((item, idx) => (
                <div
                  key={`${item.id}-${idx}`}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "0.5rem",
                  }}
                >
                  <div style={{ fontSize: "0.85rem" }}>
                    <div>{item.title}</div>
                    {item.price && (
                      <div style={{ fontSize: "0.8rem", opacity: 0.8 }}>
                        {item.price}
                      </div>
                    )}
                    {(item.flowerColor ||
                      item.stemColor ||
                      item.flowerType ||
                      item.sizeChoice) && (
                      <div
                        style={{
                          fontSize: "0.75rem",
                          opacity: 0.8,
                          marginTop: "0.15rem",
                        }}
                      >
                        {item.flowerColor &&
                          `Fleur (couleur) : ${item.flowerColor}`}
                        {item.flowerColor &&
                        (item.stemColor || item.flowerType || item.sizeChoice)
                          ? " | "
                          : ""}
                        {item.stemColor && `Tige/métal : ${item.stemColor}`}
                        {item.stemColor && (item.flowerType || item.sizeChoice)
                          ? " | "
                          : ""}
                        {item.flowerType && `Type : ${item.flowerType}`}
                        {item.flowerType && item.sizeChoice ? " | " : ""}
                        {item.sizeChoice && `Taille : ${item.sizeChoice}`}
                      </div>
                    )}
                  </div>
                  <button
                    onClick={() => removeFromCart(item.id)}
                    style={{
                      background: "#7b1b1b",
                      color: "white",
                      border: "none",
                      cursor: "pointer",
                      borderRadius: "50%",
                      width: "22px",
                      height: "22px",
                      fontSize: "0.75rem",
                    }}
                  >
                    X
                  </button>
                </div>
              ))}

              <p
                style={{
                  marginTop: "0.5rem",
                  marginBottom: "0.4rem",
                  fontWeight: "bold",
                  fontSize: "0.9rem",
                  color: "#d4af37",
                }}
              >
                Montant du panier : {cartTotal.toFixed(2)} €
              </p>

              <button
                onClick={handleMail}
                style={{
                  background:
                    "linear-gradient(135deg, #f8e7b5 0%, #d4af37 45%, #b68a2b 100%)",
                  color: "#1a1307",
                  padding: "0.5rem",
                  marginTop: "0.4rem",
                  width: "100%",
                  cursor: "pointer",
                  border: "none",
                  borderRadius: "999px",
                  fontWeight: 600,
                }}
              >
                Commander par email
              </button>

              <button
                onClick={() => setCartOpen(false)}
                style={{
                  background: "none",
                  border: "1px solid #8a6d3b",
                  color: "#f8f3e8",
                  padding: "0.4rem",
                  marginTop: "0.5rem",
                  width: "100%",
                  cursor: "pointer",
                  borderRadius: "999px",
                  fontSize: "0.8rem",
                }}
              >
                Continuer les achats
              </button>
            </>
          )}
        </div>
      )}

      {/* PLEIN ÉCRAN IMAGE + GALERIE DÉTAILLÉE */}
      {fullscreenImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background:
              "radial-gradient(circle at center, #32210f 0, #000 70%)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            padding: "1.5rem",
          }}
        >
          <button
            onClick={closeFullscreen}
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              fontSize: "2.2rem",
              background: "rgba(0,0,0,0.65)",
              color: "#f8f3e8",
              border: "1px solid #d4af37",
              borderRadius: "50%",
              width: "48px",
              height: "48px",
              cursor: "pointer",
              zIndex: 20000,
            }}
          >
            ❌
          </button>

          {/* Image principale */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
              maxWidth: "90%",
            }}
            onTouchStart={handleFsTouchStart}
            onTouchEnd={handleFsTouchEnd}
          >
            {fullscreenImages.length > 1 && (
              <button
                onClick={goPrevFullscreen}
                style={{
                  background: "none",
                  border: "1px solid #d4af37",
                  color: "#f8f3e8",
                  borderRadius: "50%",
                  width: "36px",
                  height: "36px",
                  marginRight: "0.5rem",
                  cursor: "pointer",
                }}
              >
                ◀
              </button>
            )}
            <img
              src={fullscreenSrc}
              alt={fullscreenImage.title}
              style={{
                maxWidth: "80vw",
                maxHeight: "70vh",
                objectFit: "contain",
                boxShadow: "0 0 30px rgba(212,175,55,0.45)",
                borderRadius: "14px",
                border: "1px solid #8a6d3b",
                backgroundColor: "#050403",
              }}
            />
            {fullscreenImages.length > 1 && (
              <button
                onClick={goNextFullscreen}
                style={{
                  background: "none",
                  border: "1px solid #d4af37",
                  color: "#f8f3e8",
                  borderRadius: "50%",
                  width: "36px",
                  height: "36px",
                  marginLeft: "0.5rem",
                  cursor: "pointer",
                }}
              >
                ▶
              </button>
            )}
          </div>

          {/* Miniatures */}
          {fullscreenImages.length > 1 && (
            <div
              style={{
                display: "flex",
                gap: "0.5rem",
                marginBottom: "1rem",
                maxWidth: "90%",
                overflowX: "auto",
              }}
            >
              {fullscreenImages.map((src, idx) => (
                <img
                  key={idx}
                  src={src}
                  alt={`${fullscreenImage.title} ${idx + 1}`}
                  onClick={() => setFullscreenIndex(idx)}
                  style={{
                    width: "70px",
                    height: "70px",
                    objectFit: "cover",
                    borderRadius: "6px",
                    border:
                      idx === fullscreenIndex
                        ? "2px solid #d4af37"
                        : "1px solid #444",
                    cursor: "pointer",
                  }}
                />
              ))}
            </div>
          )}

          {/* Titre, prix, description */}
          <div
            style={{
              maxWidth: "800px",
              textAlign: "center",
              color: "#f9f3e5",
            }}
          >
            <h2 style={{ marginBottom: "0.4rem" }}>
              {fullscreenImage.title}
            </h2>
            {fullscreenImage.price && (
              <p
                style={{
                  fontSize: "1.2rem",
                  color: "#d4af37",
                  marginBottom: "0.8rem",
                }}
              >
                {fullscreenImage.price}
              </p>
            )}
            {fullscreenImage.description && (
              <div
                style={{
                  fontSize: "0.95rem",
                  lineHeight: 1.5,
                  background: "rgba(0,0,0,0.5)",
                  padding: "0.8rem 1rem",
                  borderRadius: "10px",
                  border: "1px solid #8a6d3b",
                }}
              >
                {fullscreenImage.description}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
